import React, { useEffect, useState, useRef } from "react";
import "./../Styles/Admin.css";
import logoLight from "./../Images/tsqs-hm-ft-logo1.gif";
import logoDark from "./../Images/tsqs-hm-ft-logo.gif";
import axios from "axios";
import CreateGoal from "./CreateGoal";
import AssignGoal from "./AssignGoal";
import lottie from "lottie-web";
import Lottie from "lottie-react";
import comingSoonAnimation from "./../ani/comingsoon.json";
import Notifications from "./../Components/Notifications"; // Import Notifications component
import EmployeeDetailsDialog from "./EmployeeDetailsDialog";
import { TailSpin } from "react-loader-spinner"; // Using react-loader-spinner
import ProfileDialog from "./ProfileDialog";
import LeadManagement from "./LeadManagement"; // Adjust the path based on your file structure
import AssignedGoalsSection from "./AssignedGoalsSection";
import { useToast } from './ToastContext';
import { useConfirm } from './ConfirmDialog';
import AppHeader from './AppHeader';

const apiUrl = process.env.REACT_APP_API_URL;

const Admin = () => {
  const showToast = useToast();
  const confirm = useConfirm();
  const [employees, setEmployees] = useState([]);
  const [showCreateGoalDialog, setShowCreateGoalDialog] = useState(false);
  const [showAssignGoalDialog, setShowAssignGoalDialog] = useState(false);
  const [managerInfo, setManagerInfo] = useState({
    full_name: "",
    job_title: "",
  });
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [employeeDetails, setEmployeeDetails] = useState([]);
  const [finalRating, setFinalRating] = useState("");
  const [submissionSuccess, setSubmissionSuccess] = useState(false); // State for submission success message
  const VALID_ADMIN_SECTIONS = ['employees', 'assigned_goals', 'reports', 'leads', 'projects', 'updates'];
  const [currentSection, setCurrentSection] = useState(() => {
    const savedSection = localStorage.getItem('admin_currentSection');
    return VALID_ADMIN_SECTIONS.includes(savedSection) ? savedSection : 'employees';
  });

  useEffect(() => {
    if (VALID_ADMIN_SECTIONS.includes(currentSection)) {
      localStorage.setItem('admin_currentSection', currentSection);
    }
  }, [currentSection]);
  const reportsContainer = useRef(null);
  const projectsContainer = useRef(null);
  const performanceContainer = useRef(null);
  const updatesContainer = useRef(null);
  const [quarters, setQuarters] = useState([]);
  const [selectedQuarter, setSelectedQuarter] = useState(''); // Will be set after quarters load
  const [noGoalsMessage, setNoGoalsMessage] = useState("");
  const [error, setError] = useState(null);
  const [isMainManagerFlag, setIsMainManagerFlag] = useState(false); //for goal assigning
  const [goals, setGoals] = useState([]);
  const [selectedGoals, setSelectedGoals] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [goalsDropdownOpen, setGoalsDropdownOpen] = useState(false);
  const [employeesDropdownOpen, setEmployeesDropdownOpen] = useState(false);
  const [showUpdateMessage, setShowUpdateMessage] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [loading, setLoading] = useState(false); // Loading state
  const goalsDropdownRef = useRef(null);
  const employeesDropdownRef = useRef(null);
  //for profile
  const [isProfileDialogOpen, setProfileDialogOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  // Fetch quarters from DB
  useEffect(() => {
    axios.get(`${apiUrl}/api/quarters`)
      .then(res => {
        const qs = res.data.map(q => q.quarter);
        setQuarters(qs);
        if (qs.length > 0) setSelectedQuarter(qs[0]);
      })
      .catch(err => console.error('Error fetching quarters:', err));
  }, []);

  const handleDropdownClick = (dropdownName) => {
    setActiveDropdown(activeDropdown === dropdownName ? null : dropdownName);
  };

  useEffect(() => {
    const handleClickOutsideDropdown = (event) => {
      if (!event.target.closest('.goals-dropdown')) {
        setActiveDropdown(null);
      }
    };
    document.addEventListener('click', handleClickOutsideDropdown);
    return () => {
      document.removeEventListener('click', handleClickOutsideDropdown);
    };
  }, []);
  //goal submission details
  const [reviewerRatingError, setReviewerRatingError] = useState(false);
  const [finalRatingError, setFinalRatingError] = useState(false);
  const [reviewerCommentError, setReviewerCommentError] = useState(false);
  const [hasError, setHasError] = useState(false); // General error state
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const goalsResponse = await axios.get(`${apiUrl}/api/goals`);
        console.log("Fetched goals:", goalsResponse.data); // Debugging
        setGoals(goalsResponse.data);
        const employeesResponse = await axios.get(`${apiUrl}/api/employees`);
        console.log("Fetched employees:", employeesResponse.data); // Debugging
        setEmployees(employeesResponse.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        goalsDropdownRef.current &&
        !goalsDropdownRef.current.contains(event.target)
      ) {
        setGoalsDropdownOpen(false);
      }
      if (
        employeesDropdownRef.current &&
        !employeesDropdownRef.current.contains(event.target)
      ) {
        setEmployeesDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // useEffect(() => {
  //     setFilteredEmployees(employees.filter(employee =>
  //         employee.full_name.toLowerCase().includes(searchTerm.toLowerCase())
  //     ));
  // }, [searchTerm, employees]);
  useEffect(() => {
    // Filter employees based on the search term
    setFilteredEmployees(
      employees.filter(
        (employee) =>
          employee.full_name &&
          employee.full_name.toLowerCase().includes(searchTerm.toLowerCase()),
      ),
    );
  }, [searchTerm, employees]);

  const handleCheckboxChange = (setStateFunction, value) => {
    setStateFunction((prev) => {
      if (prev.includes(value)) {
        return prev.filter((item) => item !== value);
      } else {
        return [...prev, value];
      }
    });
  };

  const handleAssignGoal = async () => {
    if (selectedGoals.length === 0 || selectedEmployees.length === 0) {
      showToast("Please select at least one goal and one employee.", "warning");
      return;
    }
    setIsLoading(true); // Start loading
    try {
      console.log(
        "Assigning goals:",
        selectedGoals,
        "to employees:",
        selectedEmployees,
      );
      await axios.post(`${apiUrl}/api/assign-goal`, {
        goalIds: selectedGoals,
        employeeIds: selectedEmployees,
      });
      setShowUpdateMessage(true);
      setTimeout(() => {
        setShowUpdateMessage(false);
      }, 10000);
    } catch (error) {
      console.error("Error assigning goals:", error);
      setIsLoading(false); // Start loading
      showToast("Error assigning goals. Please try again.", "error");
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  useEffect(() => {
    // Load and play the Lottie animations for different sections
    lottie.loadAnimation({
      container: reportsContainer.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: comingSoonAnimation,
    });

    lottie.loadAnimation({
      container: projectsContainer.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: comingSoonAnimation,
    });

    lottie.loadAnimation({
      container: performanceContainer.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: comingSoonAnimation,
    });

    lottie.loadAnimation({
      container: updatesContainer.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: comingSoonAnimation,
    });

    // Clean up animations on component unmount
    return () => {
      lottie.destroy();
    };
  }, []);

  //newly addedd 22-08:1:37
  useEffect(() => {
    const managerId = localStorage.getItem("employeeId");
    if (!managerId) {
      console.error("Manager ID not found in local storage.");
      return;
    }

    // Fetch manager info
    axios
      .get(`${apiUrl}/api/manager-info/${managerId}`)
      .then((response) => {
        setManagerInfo(response.data);
        console.log("Manager Info:", response.data);

        const isMainManager = response.data.is_main_manager;
        console.log("isMainManager:", isMainManager); // Log to verify value
        setIsMainManagerFlag(isMainManager);
        // Fetch employees based on manager type
        axios
          .get(`${apiUrl}/api/employees`, {
            params: {
              managerId: managerId,
              isMainManager: isMainManager, // Make sure to pass this correctly
            },
          })

          .then((response) => setEmployees(response.data))
          .catch((error) => setError("Error fetching employee data: " + error));
      })
      .catch((error) => setError("Error fetching manager info: " + error));
  }, []);

  const handleCreateGoal = () => {
    setShowCreateGoalDialog(true);
  };

  // Handler to close both dialogs
  const closeDialogs = () => {
    setShowAssignGoalDialog(false);
    setShowCreateGoalDialog(false);
  };

  // Retrieve managerId from localStorage
  const managerId = localStorage.getItem("employeeId");

  const handleViewDetails = (employee, quarter) => {
    // Ensure the quarter is valid before proceeding
    if (!quarter) {
      console.error("Quarter is not defined. Cannot fetch details.");
      return; // Exit if the quarter is invalid
    }

    setEmployeeDetails([]); // Clear previous results
    setNoGoalsMessage(""); // Clear any previous message
    setSelectedEmployee(employee);
    console.log(
      "Fetching details for employee number:",
      employee.employee_number,
    ); // Log the request

    axios
      .get(
        `${apiUrl}/api/employee-admin-goals/${employee.employee_number}/${encodeURIComponent(quarter)}`,
      )
      .then((response) => {
        if (response.data.length === 0) {
          setEmployeeDetails([]);
          setNoGoalsMessage(
            `No goals submitted for ${employee.employee_number} in ${quarter}.`,
          );
        } else {
          setEmployeeDetails(response.data);
          setNoGoalsMessage(""); // Clear any previous message
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          setEmployeeDetails([]);
          setNoGoalsMessage(`No goals submitted for ${employee.employee_number} in ${quarter}.`);
        } else {
          console.error("Error fetching employee details:", error);
        }
      });
  };

  const handleFinalRatingChange = (rating) => {
    setFinalRating(rating);
  };

  const handleReviewerRatingChange = (goalId, newRating) => {
    setEmployeeDetails((prevDetails) =>
      prevDetails.map((detail) =>
        detail.goal_id === goalId
          ? { ...detail, reviewer_rating: newRating }
          : detail,
      ),
    );
  };

  const handleSubmit = async () => {
    setLoading(true); // Start loading
    if (!selectedEmployee) return;
    console.log("submitting for:", selectedEmployee.employee_number);

    let hasError = false; // Local variable for error flag
    // Validate reviewer ratings for each goal
    const updatedEmployeeDetails = employeeDetails.map((detail) => {
      //Creating a copy of the details object
      const updtedDetail = { ...detail };
    //   console.log(updatedDetail);
    //   console.log("reviewer_rating:", updatedDetail.reviewer_rating);
      if (!updtedDetail.reviewer_rating) {
        console.log("*Required");
        updtedDetail.reviewerRatingError = "Reviewer rating is required"; // Add error to each detail
        hasError = true;
      } else {
        updtedDetail.reviewerRatingError = null; // Clear any existing error
        console.log("Valid reviewer rating for goal_id");
      }
      return updtedDetail;
    });

    // Validate final rating
    if (!finalRating) {
      console.log("Error: Final rating is required");
      setFinalRatingError("*Required");
      hasError = true;
    } else {
      setFinalRatingError(null);
    }

    // Validate reviewer comment
    if (!employeeDetails[0]?.reviewer_comment) {
      console.log("Error: Reviewer comment is required");
      setReviewerCommentError("*Reviewer Comment is required");
      hasError = true;
    } else {
      setReviewerCommentError(null);
    }

    // Stop the submission if any validation error exists
    if (hasError) {
      setEmployeeDetails(updatedEmployeeDetails);
      setLoading(false); // Stop loading
      return;
    }
    try {
      // Continue with submission if validation passes
      console.log("Validation passed. Proceeding to submit data...");
      // Submit individual goal reviews
      const goalReviewsData = {
        goals: employeeDetails.map((detail) => ({
          goalId: detail.goal_id,
          reviewerRating: detail.reviewer_rating,
        })),
        employeeId: selectedEmployee.employee_number,
      };

      const goalReviewsResponse = await axios.post(
        `${apiUrl}/api/submit-goal-reviews`,
        goalReviewsData,
      );
      console.log("Goal reviews response:", goalReviewsResponse);

      // Submit final rating and reviewer comment
      const finalReviewData = {
        employeeId: selectedEmployee.employee_number,
        finalRating,
        reviewerComment: employeeDetails[0]?.reviewer_comment,
        quarter: selectedQuarter, // Add the selected quarter here
      };

      const finalReviewResponse = await axios.post(
        `${apiUrl}/api/submit-final-review`,
        finalReviewData,
      );

      console.log("Final review submitted:", finalReviewResponse.data);
      console.log("Goal reviews submitted:", goalReviewsResponse.data);
      // setSelectedEmployee(null);
      setLoading(false); // Stop loading
      setSubmissionSuccess(true);

      // Reset the selected employee and success message after a delay
      setTimeout(() => {
        // setSelectedEmployee(null);
        setSubmissionSuccess(false);
      }, 6000); // 10  seconds delay
    } catch (error) {
      console.error("Error submitting data:", error);
      setLoading(false); // Stop loading on error
    }
  };

  //profile handling
  const handleOpenProfileDialog = () => {
    setProfileDialogOpen(true);
  };

  const handleCloseProfileDialog = () => {
    setProfileDialogOpen(false);
  };

  const renderDetailsDialog = () => {
    if (!selectedEmployee) return null;

    return (
      <div className="details-dialog-overlay">
        <div className="details-dialog">
          <h2>Details of {selectedEmployee.full_name}</h2>
          <div className="quarter-selector">
            <label htmlFor="quarter">Select Quarter:</label>
            <select
              id="quarter"
              value={selectedQuarter}
              onChange={(e) => {
                setSelectedQuarter(e.target.value);
                handleViewDetails(selectedEmployee, e.target.value);
              }}
            >
              {quarters.map(q => (
                <option key={q} value={q}>{q}</option>
              ))}
            </select>
          </div>

          <div className="employee-summary">
            <div className="summary-item">
              <p>
                <strong>Full Name:</strong> {selectedEmployee.full_name}
              </p>
            </div>
            <div className="summary-item">
              <p>
                <strong>Location:</strong> {selectedEmployee.location}
              </p>
            </div>
            <div className="summary-item">
              <p>
                <strong>Job Title:</strong> {selectedEmployee.job_title}
              </p>
            </div>
            <div className="summary-item">
              <p>
                <strong>Project Name:</strong> {selectedEmployee.project_name}
              </p>
            </div>
          </div>
          {employeeDetails.length > 0 ? (
            <>
              <table className="details-table">
                <thead>
                  <tr>
                    {/* <th>Goal ID</th> */}
                    <th>Goal Description</th>
                    <th>Self Assessment</th>
                    <th>Self Rating</th>
                    <th>Communicated</th>
                    <th>Attachments</th>
                    <th>Reviewer Rating</th>
                    <th rowSpan={employeeDetails.length + 1}>
                      Final Rating
                    </th>{" "}
                    {/* New column header with row span */}
                  </tr>
                </thead>
                <tbody>
                  {employeeDetails.map((detail, index) => (
                    // Use _id for the key since you have migrated to MongoDB
                    <tr key={detail._id}>
                      <td className="tabledisabled">
                        {detail.goal_description}
                      </td>
                      <td className="tabledisabled">
                        {detail.self_assessment || "N/A"}
                      </td>
                      <td className="tabledisabled">
                        {detail.self_rating || "N/A"}
                      </td>
                      <td className="tabledisabled">
                        {detail.communicated ? "Yes" : "No"}
                      </td>
                      <td className="tabledisabled">
                        {detail.attachments ? (
                          <a
                            href={detail.attachments}
                            target="_blank"
                            className="attachment-link"
                            rel="noopener noreferrer"
                          >
                            View Attachment
                          </a>
                        ) : (
                          "None"
                        )}
                      </td>
                      
                      {/* Reviewer Rating: Single cell using dropdown */}
                      <td className="tabledisabled">{detail.reviewer_rating || 'N/A'}</td>

                      {/* Final Rating: Row spanned for the whole group */}
                      {index === 0 && (
                        <td rowSpan={employeeDetails.length}>
                          <select
                            value={finalRating}
                            onChange={(e) =>
                              handleFinalRatingChange(e.target.value)
                            }
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            {[1, 2, 3, 4, 5].map((rating) => (
                              <option key={rating} value={rating}>
                                {rating}
                              </option>
                            ))}
                          </select>
                          {finalRatingError && (
                            <div className="inline-error">
                              {finalRatingError}
                            </div>
                          )}
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="reviewer-comment-section">
                <strong>Reviewer Comment:</strong>
                <textarea
                  value={employeeDetails[0]?.reviewer_comment || ""}
                  onChange={(e) =>
                    setEmployeeDetails((prevDetails) => {
                      const updatedDetails = [...prevDetails];
                      updatedDetails[0].reviewer_comment = e.target.value;
                      return updatedDetails;
                    })
                  }
                />
                {/* Display Reviewer Comment Error */}
                {reviewerCommentError && (
                  <div className="inline-error">
                    {reviewerCommentError}
                  </div>
                )}
              </div>
            </>
          ) : (
            <p>No goals found for this employee.</p>
          )}
          {submissionSuccess && (
            <div
              className={`submission-success-message ${submissionSuccess ? "visible" : ""}`}
            >
              Submitted successfully!
            </div>
          )}
          {/* Display loading spinner and text */}
          {loading && (
            <div className="overlay-loading">
              <div className="overlay-content-loading">
                <TailSpin height="40" width="40" color="#00BFFF" />
                <span className="loading-text-loading">
                  Submitting Review...
                </span>
              </div>
            </div>
          )}

          <button onClick={() => setSelectedEmployee(null)}>Close</button>
          <button onClick={handleSubmit}>Submit</button>
        </div>
      </div>
    );
  };

  return (
    <div className="admin-page">
      <aside className="sidebar">
        <div className="logo-container">
          <>
            <img src={logoLight} alt="Company Logo" className="logo logo-light" />
            <img src={logoDark} alt="Company Logo" className="logo logo-dark" />
          </>
        </div>
       <nav className="nav-menu">
          <a
            href="#"
            className={`nav-item ${currentSection === "employees" ? "active" : ""}`}
            onClick={() => setCurrentSection("employees")}
          >
            Employees
          </a>
          <a
            href="#"
            className={`nav-item ${currentSection === "assigned_goals" ? "active" : ""}`}
            onClick={() => setCurrentSection("assigned_goals")}
          >
            Assigned Goals
          </a>
          <a
            href="#"
            className={`nav-item ${currentSection === "reports" ? "active" : ""}`}
            onClick={() => setCurrentSection("reports")}
          >
            {" "}
            Reviewed Reports
          </a>
          <a
            href="#"
            className={`nav-item ${currentSection === "leads" ? "active" : ""}`}
            onClick={() => setCurrentSection("leads")}
          >
            {" "}
            Lead Management
          </a>
          <a
            href="#"
            className={`nav-item ${currentSection === "projects" ? "active" : ""}`}
            onClick={() => setCurrentSection("projects")}
          >
            Project Reports
          </a>
          <a
            href="#"
            className={`nav-item ${currentSection === "updates" ? "active" : ""}`}
            onClick={() => setCurrentSection("updates")}
          >
            Updates
          </a>
        </nav>
      </aside>
      <main className="main-content">
        <AppHeader
          title="ADMIN DASHBOARD"
          employeeInfo={managerInfo}
          onProfileClick={handleOpenProfileDialog}
          hideLogo={true}
        />
        <div className="welcome-section">
          <h1>Hi {managerInfo.full_name}...</h1>
        </div>
        {currentSection === "assigned_goals" && (
          <AssignedGoalsSection />
        )}
        {currentSection === "employees" && (
          <div className="employee-list-section">
            <div className="employee-controls">
              <div className="controls-left">
                <h2>List of Employees</h2>
                <div className={`goals-dropdown ${activeDropdown === 'goals' ? 'active' : ''}`}>
                  <button className="dropbtn" onClick={() => handleDropdownClick('goals')}>Goals ▼</button>
                  <div className="goals-dropdown-content">
                    <a href="#" onClick={(e) => { handleCreateGoal(e); setActiveDropdown(null); }}>
                      Create Goals
                    </a>
                    <a href="#" onClick={() => { setShowAssignGoalDialog(true); setActiveDropdown(null); }}>
                      Assign Goals
                    </a>
                  </div>
                </div>
                {showAssignGoalDialog && (
                  <AssignGoal
                    loggedInManagerId={managerId}
                    isMainManagerFlag={isMainManagerFlag}
                    onClose={closeDialogs}
                  />
                )}
              </div>
              <div className="controls-right">
                {/* <input
                  type="text"
                  placeholder="Search..."
                  className="search-bar"
                  onChange={handleSearchChange}
                /> */}
                {/* <button className="sort-button">Filter</button> */}
              </div>
            </div>

            <div className="employee-table-wrapper">
              <table className="employee-table">
                <thead>
                  <tr>
                    <th>Employee Number</th>
                    <th>Full Name</th>
                    <th>Job Title</th>
                    <th>Project Name</th>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  {employees.map((employee) => (
                    <tr key={employee.employee_number}>
                      <td>{employee.employee_number || "N/A"}</td>
                      <td>{employee.full_name || "N/A"}</td>
                      <td>{employee.job_title || "N/A"}</td>
                      <td>{employee.project_name || "N/A"}</td>
                      <td>
                        <button
                          className="details-button"
                          onClick={() =>
                            handleViewDetails(employee, selectedQuarter)
                          }
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
        {currentSection === "leads" && (
          <div className="leads-section">
            <LeadManagement managerId={managerId} />{" "}
            {/* Render Lead Management section */}
          </div>
        )}
        {currentSection === "reports" && (
          <div>
            Reports COMING SOON...
            <Lottie
              animationData={comingSoonAnimation}
              className="card-animation"
            />
          </div>
        )}

        {currentSection === "projects" && (
          <div>
            Projects COMING SOON...
            <Lottie
              animationData={comingSoonAnimation}
              className="card-animation"
            />
          </div>
        )}

        {currentSection === "performance" && (
          <div>
            Performance COMING SOON...
            <Lottie
              animationData={comingSoonAnimation}
              className="card-animation"
            />
          </div>
        )}

        {currentSection === "updates" && (
          <div className="updates-section">
            {/* Render Notifications Component when 'Updates' is selected */}
            <Notifications managerId={managerId} />
          </div>
        )}
      </main>
      {showCreateGoalDialog && (
        <CreateGoal onClose={() => setShowCreateGoalDialog(false)} />
      )}

      {renderDetailsDialog()}
      {isProfileDialogOpen && (
        <ProfileDialog
          employeeInfo={managerInfo}
          onClose={handleCloseProfileDialog}
          onUpdate={(updatedData) => setManagerInfo(prev => ({ ...prev, ...updatedData }))}
        />
      )}
    </div>
  );
};

export default Admin;
